import { ChangeEvent, JSX } from "react";

interface Props {
    id?: string;
    type?: string;
    placeholder?: string;
    value?: string;
    onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
    required?: boolean;
}

export const Input = (props: Props): JSX.Element => {
    const { onChange, value, type, placeholder, required, id } = props;
    return (
        <input
            id={id}
            className={"c-input"}
            autoComplete={"off"}
            required={required}
            type={type}
            onChange={onChange}
            value={value}
            placeholder={placeholder}
        />
    );
};
